import { render, staticRenderFns } from "./Save-popin.vue?vue&type=template&id=a936e418&scoped=true&"
import script from "./Save-popin.vue?vue&type=script&lang=js&"
export * from "./Save-popin.vue?vue&type=script&lang=js&"
import style0 from "./Save-popin.vue?vue&type=style&index=0&id=a936e418&prod&scoped=true&lang=scss&"
import style1 from "./Save-popin.vue?vue&type=style&index=1&id=a936e418&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a936e418",
  null
  
)

export default component.exports